import React, { useContext, useEffect, useRef, useState } from "react";

import './GlobalSettings.css';
import Dictionary from "../dictionary/Dictionary";
import authContext from "../../context/authentication/authContex";
import Swal from "sweetalert2";
import clienteAxios from "../../config/axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faBars, faBook, faBuilding, faFileUpload, faUpload, faVoteYea } from "@fortawesome/free-solid-svg-icons";

const GlobalSettings = () => {

    const {globalSettings, updateGlobalSettings} = useContext(authContext);

    const [updated,setUpdated] = useState(globalSettings ?? {});
    const [hoveringImgContainer, setHoveringImgContainer] = useState(false);
    const [companyImg,setCompanyImg] = useState(null);
    const [previewURL, setPreviewURL] = useState(globalSettings.companyImgURL);
    const [saving,setSaving] = useState(false);

    const dictionarySectionRef = useRef(null);
    const preferencesSectionRef = useRef(null);
    const reservasCanchasSectionRef = useRef(null);
    const avisosDocsSectionRef = useRef(null);
    const companySectionRef = useRef(null);
    const fileInputRef = useRef(null);

    const actionOverImg = useRef('');
    
    const handleChangeGlobalSettings = (e) => {
        console.log(e.target.name);
        setUpdated(prevUpd => {
            let newUpd = {...prevUpd};
            if(e.target.type == 'checkbox'){
                switch(e.target.name){
                    case "ODTmustHaveRRHH":
                        newUpd = {...newUpd, ["ODTcouldHaveRRHHorSuppliers"]:false, [e.target.name]: e.target.checked}
                        break;
                    case "ODTmustHaveSuppliers":
                        newUpd = {...newUpd, ["ODTcouldHaveRRHHorSuppliers"]: false, [e.target.name]: e.target.checked}
                        break;
                    case "ODTcouldHaveRRHHorSuppliers":
                        newUpd = {...newUpd, [e.target.name]:e.target.checked, ["ODTmustHaveRRHH"]: false, ["ODTmustHaveSuppliers"]:false}
                        break;
                    default:
                        newUpd = {...newUpd, [e.target.name]:e.target.checked}
                        break;
                }
            }else if(e.target.type == 'number'){
                // Convertir a número para inputs de tipo number
                const nuevoValor = Number(e.target.value);
                console.log(`🔧 Actualizando ${e.target.name} de ${prevUpd[e.target.name]} a ${nuevoValor}`);
                newUpd = {...newUpd, [e.target.name]: nuevoValor}
            }else if(e.target.type == 'select-one' && ['cronDiaSemana', 'cronHora', 'cronMinuto'].includes(e.target.name)){
                // Convertir a número para selects de configuración de cron
                const nuevoValor = Number(e.target.value);
                newUpd = {...newUpd, [e.target.name]: nuevoValor}
            }else{
                newUpd = {...newUpd, [e.target.name]: e.target.value}
            }
            console.log("🔧 Nuevo estado updated:", newUpd.maxReservasActivasJugador);
            return newUpd;
        })
        // setUpdated(prevUpd => ({...prevUpd, [e.target.name]: e.target.type == 'checkbox' ? e.target.checked : e.target.value}));
    }

    const handleChangeDictionary = (e, seccion) => {
        setUpdated(prev => ({
            ...prev,
            dictionary: {...prev.dictionary, [seccion]: prev.dictionary[seccion].map(kv => kv.original == e.target.name ? ({...kv, actual: e.target.value}) : ({...kv}))}
        }))
    } 

    const handleSave = async () => {
        setSaving(true);
        Swal.fire({
            title: 'Aguarde a que se apliquen los cambios...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        if(Object.values(updated.dictionary ?? {}).flat().some(vk => vk.actual == '')){
            Swal.fire({
                icon:'error',
                title:'Imposible guardar!',
                text:'Ningún campo de la columna Nombre Personalizado puede estar vacío!'
            })
            return;
        }

        console.log("🔧 Enviando desde frontend:");
        console.log("🔧 maxReservasActivasJugador:", updated.maxReservasActivasJugador);
        console.log("🔧 Tipo:", typeof updated.maxReservasActivasJugador);

        let res = await updateGlobalSettings({...updated, previewURL}, companyImg, actionOverImg.current);
        if(res){
            actionOverImg.current = '';
            Swal.fire({title:"Configuración global actualizada exitosamente!", icon:'success'});
        }
        setSaving(false);
    }

    const handleScroll = (scrollingTo) => {
        switch(scrollingTo){
            case 'dictionary':
                dictionarySectionRef.current?.scrollIntoView({behavior: 'smooth'});
                break;
            case 'preferences':
                preferencesSectionRef.current?.scrollIntoView({behavior: 'smooth'});
                break;
            case 'reservasCanchas':
                reservasCanchasSectionRef.current?.scrollIntoView({behavior: 'smooth'});
                break;
            case 'avisosDocs':
                avisosDocsSectionRef.current?.scrollIntoView({behavior: 'smooth'});
                break;
            case 'company':
                companySectionRef.current?.scrollIntoView({behavior: 'smooth'});
                break;
        }
    }

    const handleSearchImgCompany = () =>{
        fileInputRef.current?.click();
    }
    const handleDragOverImgContainer = (e) =>{
        e.preventDefault();
        setHoveringImgContainer(true);
    }
    const handleDragLeaveImgContainer = (e) =>{
        e.preventDefault();
        setHoveringImgContainer(false);
    }
    const handleFileChange = (e) =>{
        const file = e.target.files[0];
        actionOverImg.current = 'CHANGED'
        if(file){
            if (file.type === 'image/jpeg') {
                setCompanyImg(file);
                const objectURL = URL.createObjectURL(file); //Crea una URL Local para previsualizar la imagen
                setPreviewURL(objectURL);
            } else Swal.fire({
                title:'Ops!',
                text:'Solo se permiten imagenes en formato .jpg',
                icon:'error'
            })
        }
    }
    const handleDropFile = (e) =>{
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        actionOverImg.current = 'CHANGED'
        if(file){
            if (file.type === 'image/jpeg') {
                setCompanyImg(file);
                const objectURL = URL.createObjectURL(file); //Crea una URL Local para previsualizar la imagen
                setPreviewURL(objectURL);
            } else Swal.fire({
                title:'Ops!',
                text:'Solo se permiten imagenes en formato .jpg',
                icon:'error'
            })
        }
    }
    const handleDeleteFile = (e) => {
        e.preventDefault();
        //Solo si ya tenia una cargada seteo que debe ser Eliminada del S3.
        if(globalSettings.companyImgURL) actionOverImg.current = 'DELETED';
        else actionOverImg.current = '';
        setPreviewURL(null);
        setCompanyImg(null);
    }

    const handleGeocodificarSalida = async () => {
        try {
            const resp = await clienteAxios.get(`/geocode?address=${encodeURIComponent(updated.direccionSalida)}`);
            const { lat, lng } = resp.data.data;
            setUpdated(prev => ({ ...prev, latSalida: lat, lngSalida: lng }));
        } catch (err) {
            console.log('Error geocodificación salida:', err.response?.data || err.message);
            const msg = err.response?.data?.message || 'Verifique la dirección ingresada';
            Swal.fire({ icon: 'warning', title: 'No se pudo geocodificar', text: msg });
        }
    };

    useEffect(()=>{
        setPreviewURL(globalSettings.companyImgURL);
        setUpdated(globalSettings ?? {});
    },[globalSettings])

    return <div className="globalSettingsView">

        <div className="topNavigationBar">
            <div className="topNavBarContent">
                <h4 onClick={()=>handleScroll('dictionary')}>Diccionario <FontAwesomeIcon icon={faBook}/></h4>
                <h4 onClick={()=>handleScroll('preferences')}>Preferencias <FontAwesomeIcon icon={faVoteYea}/></h4>
                <h4 onClick={()=>handleScroll('reservasCanchas')}>Reservas de Canchas <FontAwesomeIcon icon={faBars}/></h4>
                <h4 onClick={()=>handleScroll('avisosDocs')}>Avisos Docs por Vencer <FontAwesomeIcon icon={faBars}/></h4>
                <h4 onClick={()=>handleScroll('company')}>Compañia <FontAwesomeIcon icon={faBuilding}/></h4>
            </div>
        </div>

        <Dictionary ref={dictionarySectionRef} updated={updated} setUpdated={setUpdated} handleChange={handleChangeDictionary} handleSave={handleSave}/>

        <div className="globalSettingsChildContainer" ref={preferencesSectionRef}>
            <h3>Preferencias</h3>
            <div className="openNewTabSetup">
                <div className="inputGroup">
                    <h5>Abrir una nueva pestaña en el navegador al hacer clic en los siguientes botones</h5>
                    <input name="openNewtab" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.openNewTab} checked={updated.openNewtab} type="checkbox"/>
                </div>
                <div className="imagesContainer">
                    <img style={{borderRadius:'10px'}} src="./VencidosBoton.png"/>
                    <img style={{borderRadius:'10px'}} src="./verODTBoton.png"/>
                    <img style={{borderRadius:'10px'}} src="./verCKBoton.png"/>
                    <img style={{borderRadius:'10px'}} src="./porVencerBoton.png"/>
                </div>
            </div>

            <div className="fecFinODT">
                <div className="inputGroup">
                    <h5>No calcula procedimientos si el activo está <span className="spanFSERV">Fuera de Servicio</span></h5>
                    <input name="behaviourProcsCalculatedOoS" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.behaviourProcsCalculatedOoS} checked={updated.behaviourProcsCalculatedOoS} type="checkbox"/>
                </div>
            </div>
            
            <div className="fecFinODT">
                <div className="inputGroup">
                    <h5>Permite elegir Fecha de Finalización de ODT</h5>
                    <input name="allowChooseEndDateODT" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.allowChooseEndDateODT} checked={updated.allowChooseEndDateODT} type="checkbox"/>
                </div>
                <div className="imagesContainer">
                    <img style={{borderRadius:'10px'}} src="./fechaFinalizadaODT.png"/>
                </div>
            </div>
            
            <div className="optionsShouldMustHaveODT">
                 <p style={{fontSize: '0.85rem', width:'10%', marginTop:'4.5rem', color: '#666', margin: '0 0 10px 0'}}>
                    No aplica para ODTs con posibilidad de finalización integrada al guardado
                </p>
                <div className="mustHaveODT">
                    <h5>Para finalizar una ODT deben existir registros de</h5>
                    <div className="checkMustHaveODT">
                        <input name="ODTmustHaveComponents" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.ODTmustHaveComponents} checked={updated.ODTmustHaveComponents} type="checkbox"/>
                        <label>y</label>
                        <input name="ODTmustHaveRRHH" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.ODTmustHaveRRHH} checked={updated.ODTmustHaveRRHH} type="checkbox"/>
                        <label>y</label>
                        <input name="ODTmustHaveSuppliers" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.ODTmustHaveSuppliers} checked={updated.ODTmustHaveSuppliers} type="checkbox"/>
                    </div>
                    <div className="imagesContainer">
                        <img style={{borderRadius:'10px'}} src="./debeTenerODT.png"/>
                    </div>
                    <div className="checkMustHaveODT" id="checkCouldHaveODT">
                        <input name="ODTcouldHaveRRHHorSuppliers" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.ODTcouldHaveRRHHorSuppliers} checked={updated.ODTcouldHaveRRHHorSuppliers} type="checkbox"/>
                        <label>o</label>
                        <input name="ODTcouldHaveRRHHorSuppliers" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.ODTcouldHaveRRHHorSuppliers} checked={updated.ODTcouldHaveRRHHorSuppliers} id="couldHaveSupplierODT" type="checkbox"/>
                    </div>
                    <div className="imagesContainer">
                        <img style={{borderRadius:'10px'}} src="./puedeTenerODT.png"/>
                    </div>
                </div>
             
            </div>

            <div className="pestanasAdicionalesODT">
                <h5>Pestañas Adicionales ODT</h5>
                <div className="checkPestanasODT">
                    <div className="pestanaItem">
                        <label>
                            <input name="ODTshowPeligros" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.ODTshowPeligros ?? true} type="checkbox"/>
                            Peligros Posibles
                        </label>
                        {(updated.ODTshowPeligros ?? true) && <label className="subCheckbox">
                            <input name="ODTcheckboxPeligros" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.ODTcheckboxPeligros ?? false} type="checkbox"/>
                            Ingreso de datos por checkbox
                        </label>}
                    </div>
                    <div className="pestanaItem">
                        <label>
                            <input name="ODTshowHerramientas" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.ODTshowHerramientas ?? true} type="checkbox"/>
                            Herramientas
                        </label>
                        {(updated.ODTshowHerramientas ?? true) && <label className="subCheckbox">
                            <input name="ODTcheckboxHerramientas" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.ODTcheckboxHerramientas ?? false} type="checkbox"/>
                            Ingreso de datos por checkbox
                        </label>}
                    </div>
                    <div className="pestanaItem">
                        <label>
                            <input name="ODTshowEPP" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.ODTshowEPP ?? true} type="checkbox"/>
                            Elementos de Protección Personal (EPP)
                        </label>
                        {(updated.ODTshowEPP ?? true) && <label className="subCheckbox">
                            <input name="ODTcheckboxEPP" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.ODTcheckboxEPP ?? false} type="checkbox"/>
                            Ingreso de datos por checkbox
                        </label>}
                    </div>
                    <div className="pestanaItem">
                        <label>
                            <input name="ODTshowEQPG" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.ODTshowEQPG ?? true} type="checkbox"/>
                            Equipamiento de Protección Grupal (EQPG)
                        </label>
                        {(updated.ODTshowEQPG ?? true) && <label className="subCheckbox">
                            <input name="ODTcheckboxEQPG" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.ODTcheckboxEQPG ?? false} type="checkbox"/>
                            Ingreso de datos por checkbox
                        </label>}
                    </div>
                </div>
            </div>

            <hr style={{margin: '20px 0'}} />
            <div className="inputGroup">
                <label className="allowPartialFailedCtrlsODTLabel">
                    <input name="allowPartialFailedCtrlsODT" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.allowPartialFailedCtrlsODT ?? false} type="checkbox"/>
                    <label>Permitir generar ODT sobre Registros de Checklists sin seleccionar la totalidad de los controles fallidos.</label>
                </label>
            </div>
            <hr style={{margin: '20px 0'}} />
            <div className="inputGroup">
                <label className="allowPartialFailedCtrlsODTLabel">
                    <input name="hideCorrectivosProcsProgramados" onChange={(e)=>handleChangeGlobalSettings(e)} checked={updated.hideCorrectivosProcsProgramados ?? false} type="checkbox"/>
                    <label>Omitir Procedimientos Correctivos en Procedimientos Programados</label>
                </label>
            </div>
            <hr style={{margin: '20px 0'}} />

            <div className="fecFinODT">
                <h5>Punto de Salida para Rutas OPD</h5>
                <small style={{display: 'block', marginBottom: '10px', color: '#666'}}>
                    Dirección desde donde se inician las rutas de entrega de OPDs.
                </small>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <input
                        className="companyNameInput"
                        style={{ flex: 1 }}
                        placeholder="Ej: Av. Corrientes 1234, CABA"
                        value={updated.direccionSalida || ''}
                        onChange={(e) => setUpdated(prev => ({ ...prev, direccionSalida: e.target.value, latSalida: null, lngSalida: null }))}
                    />
                    {updated.direccionSalida && !updated.latSalida && (
                        <button
                            type="button"
                            onClick={handleGeocodificarSalida}
                            style={{ padding: '0.4rem 0.8rem', borderRadius: '5px', border: 'none', backgroundColor: '#3d4d87', color: 'white', cursor: 'pointer', whiteSpace: 'nowrap' }}
                        >
                            Validar
                        </button>
                    )}
                    {updated.latSalida && <span style={{ color: 'green', fontSize: '0.85rem' }}>&#10003; Ubicación validada</span>}
                </div>
            </div>
        </div>

        <div className="globalSettingsChildContainer" ref={reservasCanchasSectionRef}>
            <h3>Reservas de Canchas</h3>
            <div className="inputGroup">
                <h5>Máximo de reservas vigentes permitidas para un jugador</h5>
                <input
                    className="companyNameInput"
                    name="maxReservasActivasJugador"
                    type="number"
                    min="1"
                    max="10"
                    onChange={(e)=>handleChangeGlobalSettings(e)}
                    value={updated.maxReservasActivasJugador || 1}
                />
            </div>

            <div className="inputGroup" style={{marginTop: '15px'}}>
                <h5>Cambio Automático de Máx. Reservas (Cron)</h5>
                <p style={{fontSize: '0.85rem', color: '#666', margin: '0 0 10px 0'}}>
                    Programá cambios automáticos del límite de reservas por jugador. Cada entrada define un día y hora en que el valor se actualiza.
                </p>
                {(updated.cronMaxReservas || []).map((entry, index) => (
                    <div key={index} style={{display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap'}}>
                        <div>
                            <label style={{marginRight: '5px', fontSize: '0.85rem'}}>Día:</label>
                            <select
                                value={entry.diaSemana}
                                onChange={(e) => {
                                    const nuevas = [...(updated.cronMaxReservas || [])];
                                    nuevas[index] = {...nuevas[index], diaSemana: Number(e.target.value)};
                                    setUpdated(prev => ({...prev, cronMaxReservas: nuevas}));
                                }}
                                style={{padding: '3px', fontSize: '0.8rem'}}
                            >
                                <option value={0}>Domingo</option>
                                <option value={1}>Lunes</option>
                                <option value={2}>Martes</option>
                                <option value={3}>Miércoles</option>
                                <option value={4}>Jueves</option>
                                <option value={5}>Viernes</option>
                                <option value={6}>Sábado</option>
                            </select>
                        </div>
                        <div>
                            <label style={{marginRight: '5px', fontSize: '0.85rem'}}>Hora:</label>
                            <input
                                type="time"
                                value={`${String(entry.hora ?? 0).padStart(2, '0')}:${String(entry.minuto ?? 0).padStart(2, '0')}`}
                                onChange={(e) => {
                                    const [h, m] = e.target.value.split(':').map(Number);
                                    const nuevas = [...(updated.cronMaxReservas || [])];
                                    nuevas[index] = {...nuevas[index], hora: h, minuto: m};
                                    setUpdated(prev => ({...prev, cronMaxReservas: nuevas}));
                                }}
                                style={{padding: '3px', fontSize: '0.8rem'}}
                            />
                        </div>
                        <div>
                            <label style={{marginRight: '5px', fontSize: '0.85rem'}}>Máx. reservas:</label>
                            <input
                                type="number" min="1" max="10"
                                value={entry.valor}
                                onChange={(e) => {
                                    const nuevas = [...(updated.cronMaxReservas || [])];
                                    nuevas[index] = {...nuevas[index], valor: Number(e.target.value)};
                                    setUpdated(prev => ({...prev, cronMaxReservas: nuevas}));
                                }}
                                style={{width: '32px', padding: '3px', fontSize: '0.8rem'}}
                            />
                        </div>
                        <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => {
                                const nuevas = (updated.cronMaxReservas || []).filter((_, i) => i !== index);
                                setUpdated(prev => ({...prev, cronMaxReservas: nuevas}));
                            }}
                        >
                            Eliminar
                        </button>
                    </div>
                ))}
                <button
                    className="btn btn-outline-primary btn-sm"
                    style={{marginTop: '5px'}}
                    onClick={() => {
                        const nuevas = [...(updated.cronMaxReservas || []), { diaSemana: 0, hora: 12, minuto: 0, valor: 1 }];
                        setUpdated(prev => ({...prev, cronMaxReservas: nuevas}));
                    }}
                >
                    + Agregar Programación
                </button>
            </div>

            <div className="inputGroup" style={{marginTop: '15px'}}>
                <h5>Validar reemplazo de jugadores al editar reserva</h5>
                <p style={{fontSize: '0.85rem', color: '#666', margin: '0 0 8px 0'}}>
                    Impide que un socio utilice los reemplazos para eludir el límite de reservas vigentes.
                    Al activarse, verifica que los nuevos jugadores no tengan reservas cuya fecha y hora
                    de finalización sean posteriores a la fecha y hora de creación de la reserva que se
                    intenta modificar.
                </p>
                <input
                    name="validarReemplazoJugadores"
                    onChange={(e)=>handleChangeGlobalSettings(e)}
                    checked={updated.validarReemplazoJugadores ?? false}
                    type="checkbox"
                />
            </div>

            <div className="inputGroup" style={{marginTop: '15px'}}>
                <h5>Enviar notificaciones push</h5>
                <p style={{fontSize: '0.85rem', color: '#666', margin: '0 0 8px 0'}}>
                    Controla el envío de notificaciones a los dispositivos móviles para los eventos
                    de reservas de canchas (creación, edición, cancelación, suspensión, reactivación,
                    eliminación y recordatorios). Si se desactiva, los usuarios ya no recibiran notificaciones, ni Push ni visualizables en la bandeja de notificaciones dentro de la app.
                </p>
                <input
                    name="enviarPushReservasCanchas"
                    onChange={(e)=>handleChangeGlobalSettings(e)}
                    checked={updated.enviarPushReservasCanchas ?? true}
                    type="checkbox"
                />
            </div>

            <hr style={{margin: '20px 0'}} />

            <h5 style={{marginBottom: '15px'}}>Apertura Automática de Fechas (Cron)</h5>

            <div className="inputGroup">
                <h6>El cron se ejecuta cada:</h6>
                <div style={{display: 'flex', gap: '15px', alignItems: 'center', marginTop: '10px'}}>
                    <div>
                        <label style={{marginRight: '5px'}}>Día:</label>
                        <select
                            name="cronDiaSemana"
                            onChange={(e)=>handleChangeGlobalSettings(e)}
                            value={updated.cronDiaSemana ?? 2}
                            style={{padding: '5px'}}
                        >
                            <option value="0">Domingo</option>
                            <option value="1">Lunes</option>
                            <option value="2">Martes</option>
                            <option value="3">Miércoles</option>
                            <option value="4">Jueves</option>
                            <option value="5">Viernes</option>
                            <option value="6">Sábado</option>
                        </select>
                    </div>
                    <div>
                        <label style={{marginRight: '5px'}}>Hora:</label>
                        <input
                            type="time"
                            value={`${String(updated.cronHora ?? 1).padStart(2, '0')}:${String(updated.cronMinuto ?? 27).padStart(2, '0')}`}
                            onChange={(e) => {
                                const [h, m] = e.target.value.split(':').map(Number);
                                setUpdated(prev => ({...prev, cronHora: h, cronMinuto: m}));
                            }}
                            style={{padding: '5px'}}
                        />
                    </div>
                </div>
            </div>

            <div className="inputGroup" style={{marginTop: '20px'}}>
                <h6>Días que se abren automáticamente:</h6>
                <div style={{display: 'flex', gap: '15px', marginTop: '10px', flexWrap: 'wrap'}}>
                    {['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'].map((dia, index) => (
                        <label key={index} style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                            <input
                                type="checkbox"
                                checked={(updated.diasAAbrir || [3, 4, 5]).includes(index)}
                                onChange={(e) => {
                                    const diasActuales = updated.diasAAbrir || [3, 4, 5];
                                    const nuevosDias = e.target.checked
                                        ? [...diasActuales, index].sort((a, b) => a - b)
                                        : diasActuales.filter(d => d !== index);
                                    setUpdated(prev => ({...prev, diasAAbrir: nuevosDias}));
                                }}
                            />
                            {dia}
                        </label>
                    ))}
                </div>
            </div>

            <hr style={{margin: '20px 0'}} />

            <h5 style={{marginBottom: '15px'}}>Horarios de Canchas</h5>
            <small className="text-muted" style={{display: 'block', marginBottom: '15px'}}>
                Configuración global para todas las canchas. Si una cancha necesita horarios diferentes, usa la opción de bloqueos.
            </small>

            <div style={{display: 'flex', gap: '20px', alignItems: 'center', marginTop: '10px'}}>
                <div className="inputGroup">
                    <label style={{marginRight: '5px'}}>Hora Inicio:</label>
                    <input
                        name="horaInicio"
                        type="time"
                        onChange={(e)=>handleChangeGlobalSettings(e)}
                        value={updated.horaInicio || "08:00"}
                        style={{padding: '5px'}}
                    />
                </div>
                <div className="inputGroup">
                    <label style={{marginRight: '5px'}}>Hora Fin:</label>
                    <input
                        name="horaFin"
                        type="time"
                        onChange={(e)=>handleChangeGlobalSettings(e)}
                        value={updated.horaFin || "20:30"}
                        style={{padding: '5px'}}
                    />
                </div>
                <div className="inputGroup">
                    <label style={{marginRight: '5px'}}>Intervalo (minutos):</label>
                    <input
                        name="intervaloMinutos"
                        type="number"
                        value={15}
                        disabled
                        style={{width: '70px', padding: '5px', backgroundColor: '#e9ecef', color: '#6c757d', cursor: 'not-allowed'}}
                    />
                </div>
                <div className="inputGroup">
                    <label style={{marginRight: '5px'}}>Fin de Hora Pico (por defecto):</label>
                    <input
                        name="horaFinPico"
                        type="time"
                        onChange={(e)=>handleChangeGlobalSettings(e)}
                        value={updated.horaFinPico || "20:00"}
                        style={{padding: '5px'}}
                    />
                </div>
            </div>
        </div>
        
        <div className="globalSettingsChildContainer" ref={avisosDocsSectionRef}>
            <h3>Avisos de Documentos por Vencer</h3>
            <div className="inputGroup">
                <h5>Programación de envío de avisos</h5>
                <p style={{fontSize: '0.85rem', color: '#666', margin: '0 0 10px 0'}}>
                    Programá los días y horarios en los que el sistema envía notificaciones a los administradores
                    sobre documentos vencidos o próximos a vencer. Podés agregar tantas programaciones como necesites.
                </p>
                {(updated.cronAvisosDocsPorVencer || []).map((entry, index) => (
                    <div key={index} style={{display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap'}}>
                        <div>
                            <label style={{marginRight: '5px', fontSize: '0.85rem'}}>Día:</label>
                            <select
                                value={entry.diaSemana}
                                onChange={(e) => {
                                    const nuevas = [...(updated.cronAvisosDocsPorVencer || [])];
                                    nuevas[index] = {...nuevas[index], diaSemana: Number(e.target.value)};
                                    setUpdated(prev => ({...prev, cronAvisosDocsPorVencer: nuevas}));
                                }}
                                style={{padding: '3px', fontSize: '0.8rem'}}
                            >
                                <option value={0}>Domingo</option>
                                <option value={1}>Lunes</option>
                                <option value={2}>Martes</option>
                                <option value={3}>Miércoles</option>
                                <option value={4}>Jueves</option>
                                <option value={5}>Viernes</option>
                                <option value={6}>Sábado</option>
                            </select>
                        </div>
                        <div>
                            <label style={{marginRight: '5px', fontSize: '0.85rem'}}>Hora:</label>
                            <input
                                type="time"
                                value={`${String(entry.hora ?? 0).padStart(2, '0')}:${String(entry.minuto ?? 0).padStart(2, '0')}`}
                                onChange={(e) => {
                                    const [h, m] = e.target.value.split(':').map(Number);
                                    const nuevas = [...(updated.cronAvisosDocsPorVencer || [])];
                                    nuevas[index] = {...nuevas[index], hora: h, minuto: m};
                                    setUpdated(prev => ({...prev, cronAvisosDocsPorVencer: nuevas}));
                                }}
                                style={{padding: '3px', fontSize: '0.8rem'}}
                            />
                        </div>
                        <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => {
                                const nuevas = (updated.cronAvisosDocsPorVencer || []).filter((_, i) => i !== index);
                                setUpdated(prev => ({...prev, cronAvisosDocsPorVencer: nuevas}));
                            }}
                        >
                            Eliminar
                        </button>
                    </div>
                ))}
                <button
                    className="btn btn-outline-primary btn-sm"
                    style={{marginTop: '5px'}}
                    onClick={() => {
                        const nuevas = [...(updated.cronAvisosDocsPorVencer || []), { diaSemana: 0, hora: 9, minuto: 0 }];
                        setUpdated(prev => ({...prev, cronAvisosDocsPorVencer: nuevas}));
                    }}
                >
                    + Agregar Programación
                </button>
            </div>
        </div>

        <div className="globalSettingsChildContainer companyInfo" ref={companySectionRef}>
            <h3>Compañía</h3>
            <div className="inputGroup">
                <h5>Nombre de la Empresa</h5>
                <input className="companyNameInput" name="companyName" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.companyName}/>
            </div>
            <div className="inputsCodDocsContainer">
                <div className="inputGroup">
                    <h6>Código de Documento ODT</h6>
                    <input className="companyNameInput" name="codDocODT" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.codDocODT}/>
                </div>
                <div className="inputGroup">
                    <h6>Código de Documento CHECKLIST</h6>
                    <input className="companyNameInput" name="codDocCK" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.codDocCK}/>
                </div>
                <div className="inputGroup">
                    <h6>Código de Documento CONSUMO</h6>
                    <input className="companyNameInput" name="codDocConsumo" onChange={(e)=>handleChangeGlobalSettings(e)} value={updated.codDocConsumo}/>
                </div>
            </div>
            <h5 className="logoCompanyLabel">Logo de la Empresa</h5>
            {previewURL ? <div className="previewCompanyImgContainer">
                    <img className="previewCompanyImg" src={previewURL} alt={`${updated.companyName}-imgPreview`}/>
                    <button onClick={handleDeleteFile}>Eliminar Imagen</button>
                </div>
                :
                <div className="uploadPhotoContainer">
                    <div className="dropPhotoContainer" style={hoveringImgContainer ? { borderColor: 'orange' } : {}} onClick={handleSearchImgCompany} onDrop={(e)=>handleDropFile(e)} onDragOver={handleDragOverImgContainer} onDragLeave={handleDragLeaveImgContainer}>
                        <label>Suelte una imagen aqui o presione para buscarla en sus archivos <FontAwesomeIcon icon={faFileUpload}/></label>
                    </div>
                    <input
                        type="file"
                        accept=".jpg, .jpeg"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                    />
                </div>
            }

        </div>

        <button disabled={saving} onClick={handleSave} className='saveDictionaryBtn'>guardar</button>
    </div>

}

export default GlobalSettings;